"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useHovered = _interopRequireDefault(require("../hooks/useHovered"));

var HoverProvider = function HoverProvider(props) {
  return props.children((0, _useHovered.default)(props));
};

HoverProvider.displayName = 'HoverProvider';
var _default = HoverProvider;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/providers/HoverProvider.js
// module id = 130
// module chunks = 209 210 211 212